import '../scss/index.scss';

document.addEventListener('DOMContentLoaded', function () {
    // Helpers
    function qsa(sel, parent) {
        return Array.from((parent || document).querySelectorAll(sel));
    }
    function qs(sel, parent) {
        return (parent || document).querySelector(sel);
    }

    function fadeIn(el, duration) {
        if (!el) return;
        el._fadeId = (el._fadeId || 0) + 1;
        el.style.display = 'block';
        el.style.opacity = '0';
        el.style.transition = 'opacity ' + duration + 'ms';
        requestAnimationFrame(function () {
            el.style.opacity = '1';
        });
    }
    function fadeOut(el, duration, cb) {
        if (!el) return;
        var id = (el._fadeId = (el._fadeId || 0) + 1);
        el.style.transition = 'opacity ' + duration + 'ms';
        el.style.opacity = '0';
        setTimeout(function () {
            if (el._fadeId !== id) return;
            el.style.display = 'none';
            el.style.transition = '';
            if (cb) cb();
        }, duration);
    }

    // Prevent Font Awesome SVGs from being independently focusable
    qsa('svg.svg-inline--fa').forEach(function (svg) {
        svg.setAttribute('focusable', 'false');
        svg.setAttribute('tabindex', '-1');
    });
    // Also catch FA SVGs injected after initial load (FA kit loads async)
    var faObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
            m.addedNodes.forEach(function (node) {
                if (node.nodeType === 1) {
                    if (node.matches && node.matches('svg.svg-inline--fa')) {
                        node.setAttribute('focusable', 'false');
                        node.setAttribute('tabindex', '-1');
                    }
                    qsa('svg.svg-inline--fa', node).forEach(function (svg) {
                        svg.setAttribute('focusable', 'false');
                        svg.setAttribute('tabindex', '-1');
                    });
                }
            });
        });
    });
    faObserver.observe(document.body, { childList: true, subtree: true });

    // StickyNav
    var navWrapper = qs('.nav-wrapper');
    var navOffset = navWrapper
        ? navWrapper.getBoundingClientRect().top + window.scrollY
        : 0;
    var navHeight = navWrapper ? navWrapper.offsetHeight : 0;

    window.addEventListener('scroll', function () {
        if (!navWrapper) return;
        if (window.scrollY >= navOffset && window.innerWidth > 800) {
            navWrapper.classList.add('stickyNav');
            document.body.style.paddingTop = navHeight + 'px';

            if (window.innerWidth < 801) {
                var smithBox = qs('.smith-box', navWrapper);
                if (smithBox) fadeOut(smithBox, 100);
            }
        } else {
            navWrapper.classList.remove('stickyNav');
            document.body.style.paddingTop = '0';

            if (window.innerWidth < 801) {
                var smithBox = qs('.smith-box', navWrapper);
                if (smithBox) fadeIn(smithBox, 100);
            }
        }
    });

    // Nav in page links
    if (window.innerWidth < 801) {
        var smithBox = qs('.smith-box');
        if (smithBox && smithBox.parentNode) {
            var parent = smithBox.parentNode;
            while (parent.firstChild) {
                parent.parentNode.insertBefore(parent.firstChild, parent);
            }
            parent.remove();
        }
    } else {
        var smithBox = qs('.smith-box');
        if (smithBox) smithBox.classList.remove('mobile-smith-box');
    }

    // Desktop menu: show/hide submenus with ARIA
    qsa('.menu-option__trigger').forEach(function (trigger) {
        var menuOption = trigger.parentNode;
        var submenu = qs('.submenu', menuOption);

        // Hover open/close on desktop
        if (window.innerWidth > 800) {
            menuOption.addEventListener('mouseenter', function () {
                trigger.setAttribute('aria-expanded', 'true');
                if (submenu) submenu.style.display = 'block';
            });
            menuOption.addEventListener('mouseleave', function () {
                trigger.setAttribute('aria-expanded', 'false');
                if (submenu) submenu.style.display = '';
            });
        }

        // Click toggle (works on all sizes)
        trigger.addEventListener('click', function () {
            var expanded = this.getAttribute('aria-expanded') === 'true';
            // Close all other menus first
            qsa('.menu-option__trigger').forEach(function (other) {
                other.setAttribute('aria-expanded', 'false');
                var otherSub = qs('.submenu', other.parentNode);
                if (otherSub) otherSub.classList.remove('open');
            });
            if (!expanded) {
                this.setAttribute('aria-expanded', 'true');
                if (submenu) submenu.classList.add('open');
            }
        });

        // Keyboard: Escape closes submenu
        menuOption.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') {
                trigger.setAttribute('aria-expanded', 'false');
                if (submenu) {
                    submenu.style.display = '';
                    submenu.classList.remove('open');
                }
                trigger.focus();
            }
        });
    });

    // Mobile updates
    if (window.innerWidth < 801) {
        // Move promo banner to bottom of billboard
        var promobanner = qs('.promobanner');
        var billboardWrapper = qs('.billboard-slideshow-wrapper');
        if (promobanner && billboardWrapper) {
            billboardWrapper.after(promobanner);
        }

        // Convert billboard into background image
        var firstSlide = qs('.billboard-slide');
        if (firstSlide) {
            var img = qs('a img', firstSlide);
            if (img && billboardWrapper) {
                billboardWrapper.style.background =
                    'url(' +
                    img.getAttribute('src') +
                    ') no-repeat center center';
            }
        }
    }

    // Promo banner close button
    qsa('.promobanner i.fa-times').forEach(function (el) {
        el.addEventListener('click', function () {
            var banner = qs('.promobanner');
            if (banner) banner.style.display = 'none';
        });
    });

    // Mobile nav toggle
    var navToggle = qs('.nav-toggle');
    var navClose = qs('.nav-close');
    var navLinks = qs('#nav-links');

    if (navToggle && navLinks) {
        navToggle.addEventListener('click', function () {
            navLinks.style.display = 'block';
            navToggle.setAttribute('aria-expanded', 'true');
            navToggle.style.display = 'none';
            // Focus first menu item for keyboard users
            var firstItem =
                qs('.menu-option__trigger', navLinks) || qs('a', navLinks);
            if (firstItem) firstItem.focus();
        });
    }

    if (navClose && navLinks) {
        function closeMobileNav() {
            navLinks.style.display = '';
            if (navToggle) {
                navToggle.setAttribute('aria-expanded', 'false');
                navToggle.style.display = '';
                navToggle.focus();
            }
            // Close all submenus
            qsa('.menu-option__trigger').forEach(function (t) {
                t.setAttribute('aria-expanded', 'false');
            });
            qsa('.submenu.open').forEach(function (s) {
                s.classList.remove('open');
            });
        }

        navClose.addEventListener('click', closeMobileNav);

        // Close on Escape from anywhere in nav
        if (navLinks) {
            navLinks.addEventListener('keydown', function (e) {
                if (e.key === 'Escape' && window.innerWidth < 801) {
                    closeMobileNav();
                }
            });
        }
    }

    // Billboard slideshow
    var billboardSlides = qsa('.billboard-slide');
    var billboardWrapper = qs('.billboard-slideshow-wrapper');
    var liveRegion = null;

    // Create a live region for slide announcements
    if (billboardSlides.length > 1 && billboardWrapper) {
        liveRegion = document.createElement('div');
        liveRegion.setAttribute('aria-live', 'polite');
        liveRegion.setAttribute('aria-atomic', 'true');
        liveRegion.className = 'sr-only';
        billboardWrapper.appendChild(liveRegion);
    }

    if (window.innerWidth > 800 && billboardSlides.length && billboardWrapper) {
        billboardWrapper.style.height = billboardSlides[0].offsetHeight + 'px';
    }

    function debounce(func, delay) {
        var timeoutId;
        return function () {
            var context = this;
            var args = arguments;
            clearTimeout(timeoutId);
            timeoutId = setTimeout(function () {
                func.apply(context, args);
            }, delay);
        };
    }

    if (window.innerWidth > 800 && billboardWrapper && billboardSlides.length) {
        window.addEventListener(
            'resize',
            debounce(function () {
                billboardWrapper.style.height =
                    billboardSlides[0].offsetHeight + 'px';
            }, 100)
        );
    }

    var slideshowControls = qs(
        '.billboard-slideshow-wrapper .slideshow-controls'
    );
    if (billboardSlides.length > 1 && slideshowControls) {
        billboardSlides.forEach(function (slide, i) {
            var btn = document.createElement('button');
            btn.className = 'slideshow-control';
            btn.setAttribute('role', 'tab');
            btn.setAttribute('aria-label', 'Slide ' + (i + 1));
            btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
            slideshowControls.appendChild(btn);
        });
    }

    var slideTimer = 1;
    var iterations = 0;
    var fader;
    var controls = qsa('.slideshow-control');

    if (controls.length) controls[0].classList.add('active');

    function announceSlide(index) {
        if (liveRegion) {
            liveRegion.textContent =
                'Slide ' + (index + 1) + ' of ' + billboardSlides.length;
        }
        controls.forEach(function (c, i) {
            c.classList.remove('active');
            c.setAttribute('aria-selected', 'false');
        });
        if (controls[index]) {
            controls[index].classList.add('active');
            controls[index].setAttribute('aria-selected', 'true');
        }
    }

    controls.forEach(function (control) {
        control.addEventListener('click', function () {
            var slideNum = Array.from(this.parentNode.children).indexOf(this);

            billboardSlides.forEach(function (s) {
                fadeOut(s, 400);
            });
            fadeIn(billboardSlides[slideNum], 400);
            announceSlide(slideNum);

            slideTimer = slideNum + 1;
        });
    });

    if (billboardSlides.length > 1) {
        fader = setInterval(nextSlide, 8000);

        if (billboardWrapper) {
            billboardWrapper.addEventListener('mouseenter', function () {
                clearInterval(fader);
            });
            billboardWrapper.addEventListener('mouseleave', function () {
                iterations = 0;
                fader = setInterval(nextSlide, 8000);
            });
            // Pause on focus within for keyboard users
            billboardWrapper.addEventListener('focusin', function () {
                clearInterval(fader);
            });
            billboardWrapper.addEventListener('focusout', function (e) {
                if (!billboardWrapper.contains(e.relatedTarget)) {
                    iterations = 0;
                    fader = setInterval(nextSlide, 8000);
                }
            });

            qsa('.billboard-prev, .billboard-next', billboardWrapper).forEach(
                function (el) {
                    el.style.display = 'block';
                }
            );
        }
    }

    var chevronRight = qs('.billboard-slideshow-wrapper .billboard-next');
    var chevronLeft = qs('.billboard-slideshow-wrapper .billboard-prev');
    if (chevronRight)
        chevronRight.addEventListener('click', function () {
            nextSlide();
        });
    if (chevronLeft)
        chevronLeft.addEventListener('click', function () {
            prevSlide();
        });

    function nextSlide() {
        var totalSlides = billboardSlides.length;

        billboardSlides.forEach(function (s) {
            fadeOut(s, 400);
        });

        if (slideTimer < totalSlides) {
            fadeIn(billboardSlides[slideTimer], 400);
            announceSlide(slideTimer);
            slideTimer++;
        } else {
            fadeIn(billboardSlides[0], 400);
            announceSlide(0);
            slideTimer = 1;
            iterations++;
            if (iterations >= 100) {
                clearInterval(fader);
            }
        }
    }

    function prevSlide() {
        var totalSlides = billboardSlides.length;

        billboardSlides.forEach(function (s) {
            fadeOut(s, 400);
        });

        if (slideTimer !== 1) {
            fadeIn(billboardSlides[slideTimer - 2], 400);
            announceSlide(slideTimer - 2);
            slideTimer--;
        } else {
            fadeIn(billboardSlides[totalSlides - 1], 400);
            announceSlide(totalSlides - 1);
            slideTimer = totalSlides;
        }
    }

    // Wrap leader image img in a container and move overlay into it
    var leaderOverlay = qs('.leaderImage__overlay');
    var leaderImg = qs('.leaderImage .article-image > img');
    if (leaderOverlay && leaderImg) {
        var wrapper = document.createElement('div');
        wrapper.className = 'leaderImage__imgwrap';
        leaderImg.parentNode.insertBefore(wrapper, leaderImg);
        wrapper.appendChild(leaderImg);
        wrapper.appendChild(leaderOverlay);
    }

    // Add link data attributes for tracking
    qsa('.SI-link a').forEach(function (el) {
        el.classList.add('SI_Link_Top');
    });
    qsa('.nav-wrapper a').forEach(function (el) {
        el.classList.add('Navigation_Link');
    });
    qsa('.billboard-slideshow-wrapper a').forEach(function (el) {
        el.classList.add('Billboard_Link');
    });
    qsa('.home section a').forEach(function (el) {
        var section = el.closest('section');
        if (section && section.id) {
            var sectionID =
                section.id.charAt(0).toUpperCase() + section.id.slice(1);
            el.classList.add(sectionID + '_Link');
        }
    });
    qsa('footer a').forEach(function (el) {
        el.classList.add('Footer_Link');
    });

    // Newsletter signup: allow click on images
    qsa('#form33 .subfield img').forEach(function (el) {
        el.addEventListener('click', function () {
            var input = this.nextElementSibling;
            if (input && input.tagName === 'INPUT') input.click();
        });
    });

    // Newsletter signup: prevent form submit if no items selected
    qsa('.subfield').forEach(function (el) {
        el.addEventListener('click', function () {
            var formButton = qs('#formButton');
            if (formButton) formButton.style.display = '';

            var anyChecked = qsa('.subfield input').some(function (input) {
                return input.checked;
            });
            if (anyChecked && formButton) formButton.style.display = 'none';
        });
    });

    // Carousel photo grid lightbox (grouped per slideshow)
    (function () {
        var lightbox = qs('#lightbox');
        if (!lightbox) return;

        var lbImg = qs('.lightbox__img', lightbox);
        var lbCaption = qs('.lightbox__caption', lightbox);
        var prevBtn = qs('.lightbox__prev', lightbox);
        var nextBtn = qs('.lightbox__next', lightbox);
        var triggers = qsa('[data-lightbox-group]');
        var images = [];
        var current = 0;
        var previouslyFocused = null;

        var focusableSelector =
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

        function trapFocus(e) {
            var focusable = qsa(focusableSelector, lightbox);
            if (!focusable.length) return;
            var first = focusable[0];
            var last = focusable[focusable.length - 1];
            if (e.key === 'Tab') {
                if (e.shiftKey && document.activeElement === first) {
                    e.preventDefault();
                    last.focus();
                } else if (!e.shiftKey && document.activeElement === last) {
                    e.preventDefault();
                    first.focus();
                }
            }
        }

        function updateNav() {
            var multi = images.length > 1;
            prevBtn.style.display = multi ? '' : 'none';
            nextBtn.style.display = multi ? '' : 'none';
        }

        function preload(index) {
            if (index >= 0 && index < images.length) {
                var img = new Image();
                img.src = images[index].src;
            }
        }

        function show() {
            var img = images[current];
            // Show thumbnail instantly while full image loads
            lbImg.src = img.thumb || img.src;
            lbImg.alt = img.alt || '';
            lbCaption.textContent = img.caption || '';
            if (img.thumb && img.thumb !== img.src) {
                var full = new Image();
                full.onload = function () {
                    if (images[current] === img) lbImg.src = img.src;
                };
                full.src = img.src;
            }
            // Preload adjacent images
            preload((current + 1) % images.length);
            preload((current - 1 + images.length) % images.length);
        }

        function open(triggerEl) {
            previouslyFocused = triggerEl;
            try {
                images = JSON.parse(triggerEl.getAttribute('data-images'));
            } catch (e) {
                images = [];
            }
            if (!images.length) return;
            current = 0;
            show();
            updateNav();
            lightbox.setAttribute('aria-hidden', 'false');
            document.body.style.overflow = 'hidden';
            lightbox.addEventListener('keydown', trapFocus);
            var closeBtn = qs('.lightbox__close', lightbox);
            if (closeBtn) closeBtn.focus();
        }

        function close() {
            lightbox.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
            lightbox.removeEventListener('keydown', trapFocus);
            if (previouslyFocused) {
                previouslyFocused.focus();
                previouslyFocused = null;
            }
        }

        function prev() {
            current = (current - 1 + images.length) % images.length;
            show();
        }

        function next() {
            current = (current + 1) % images.length;
            show();
        }

        triggers.forEach(function (trigger) {
            trigger.addEventListener('click', function (e) {
                e.preventDefault();
                open(this);
            });
        });

        qs('.lightbox__close', lightbox).addEventListener('click', close);
        qs('.lightbox__overlay', lightbox).addEventListener('click', close);
        prevBtn.addEventListener('click', prev);
        nextBtn.addEventListener('click', next);

        document.addEventListener('keydown', function (e) {
            if (lightbox.getAttribute('aria-hidden') !== 'false') return;
            if (e.key === 'Escape') close();
            if (e.key === 'ArrowLeft') prev();
            if (e.key === 'ArrowRight') next();
        });
    })();

    // FAQ accordion
    qsa('.faq-item__header').forEach(function (btn) {
        btn.addEventListener('click', function () {
            var expanded = this.getAttribute('aria-expanded') === 'true';
            this.setAttribute('aria-expanded', String(!expanded));
            this.nextElementSibling.hidden = expanded;
        });
    });

    // At the Smithsonian filters
    var firstCategoryEl = qs('.ats-category:first-of-type h3');
    if (firstCategoryEl) {
        var firstCategory = firstCategoryEl.textContent.toLowerCase();
        var firstCategoryName = '.' + firstCategory;

        var firstCat = qs('.ats-category:first-of-type');
        if (firstCat) {
            firstCat.classList.add('active');
            firstCat.setAttribute('aria-pressed', 'true');
        }
        qsa('.ats-filter-item').forEach(function (el) {
            el.style.display = 'none';
        });
        qsa(firstCategoryName).forEach(function (el) {
            el.style.display = '';
        });
        qsa('.ats-filter-item .text-wrapper div').forEach(function (el) {
            el.style.display = 'none';
        });
        qsa(firstCategoryName + 'item').forEach(function (el) {
            el.style.display = '';
        });

        qsa('.ats-category').forEach(function (el) {
            el.addEventListener('click', function () {
                var categoryH3 = qs('h3', this);
                if (!categoryH3) return;
                var category = categoryH3.textContent.toLowerCase();
                var categoryName = '.' + category;

                if (!this.classList.contains('active')) {
                    qsa('.ats-category').forEach(function (c) {
                        c.classList.remove('active');
                        c.setAttribute('aria-pressed', 'false');
                    });
                    this.classList.add('active');
                    this.setAttribute('aria-pressed', 'true');
                    qsa('.ats-filter-item').forEach(function (fi) {
                        fi.style.display = 'none';
                    });
                    qsa('.ats-filter-item .text-wrapper div').forEach(
                        function (d) {
                            d.style.display = 'none';
                        }
                    );
                    qsa(categoryName).forEach(function (c) {
                        c.style.display = '';
                    });
                    qsa(categoryName + 'item').forEach(function (c) {
                        c.style.display = '';
                    });
                }
            });
        });
    }
});
